import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  authors: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_AUTHORS_BUSY: (state, payload) => {
    state.authors.isBusy = payload;
  },
  LOAD_AUTHORS_SUCCESS: (state, payload) => {
    state.authors.data = payload.data;
    state.authors.error = null;
  },
  LOAD_AUTHORS_FAIL: (state, payload) => {
    state.authors.data = null;
    state.authors.error = payload;
  }
};

const actions = {
  getAuthors: ({ commit, rootState }, { projectId, pagination, search }) => {
    commit('LOAD_AUTHORS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    //in this case in pagination we will only have:searchQuery and perPage since this is a select list
    let query = '';
    if(pagination) {
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    if (search) {
      if (query) query += '&';
      query += 'query=' + search;
    }

    if (query) query = '?' + query;

    return Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/authors${query}`, config)
      .then(response => {
        commit('LOAD_AUTHORS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_AUTHORS_FAIL', error)
      })
      .finally(() => commit('LOAD_AUTHORS_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};